import React, { useState, useRef } from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useTranslation } from "../hooks/useTranslation";

function Factory() {
  const { t } = useTranslation();

const slideContent = [
  {
    title: "01",
    img: "/assets/images/slideOneNew.jpg",
      description: t("factory.slide1"),
  },
  {
    title: "02",
    img: "/assets/images/slideTwoNew.jpg",
      description: t("factory.slide2"),
  },
  {
    title: "03",
    img: "/assets/images/slideThreeNew.jpg",
      description: t("factory.slide3"),
  },
  {
    title: "04",
    img: "/assets/images/slideFourNew.jpg",
      description: t("factory.slide4"),
  },
  {
    title: "05",
    img: "/assets/images/slideFiveNew.jpg",
      description: t("factory.slide5"),
  },
];
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const dragStartX = useRef(0);
  const dragOffset = useRef(0);

  const [titleRef, titleVisible] = useScrollAnimation();
  const [headingRef, headingVisible] = useScrollAnimation();
  const [sliderRef, sliderVisible] = useScrollAnimation();

  const nextSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide((prev) => (prev + 1) % slideContent.length);
    setTimeout(() => {
      setIsTransitioning(false);
    }, 600);
  };

  const prevSlide = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentSlide(
      (prev) => (prev - 1 + slideContent.length) % slideContent.length
    );
    setTimeout(() => {
      setIsTransitioning(false);
    }, 600);
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    dragStartX.current = e.pageX || e.touches?.[0]?.pageX;
    dragOffset.current = 0;
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const currentX = e.pageX || e.touches?.[0]?.pageX;
    dragOffset.current = currentX - dragStartX.current;
  };

  const handleMouseUp = () => {
    if (!isDragging) return;
    setIsDragging(false);

    if (dragOffset.current > 50) {
      prevSlide();
    } else if (dragOffset.current < -50) {
      nextSlide();
    }
    dragOffset.current = 0;
  };

  const getImagePosition = (index) => {
    const diff = index - currentSlide;
    const total = slideContent.length;
    const normalizedDiff = (diff + total) % total;

    if (normalizedDiff === 0) return "active";
    if (normalizedDiff === 1) return "next";
    return "hidden";
  };

  return (
    <div className="factory-wrapper">
      <div className="factory container">
        <div
          ref={titleRef}
          className={`factory-title flex ${titleVisible ? "animate-in" : ""}`}
        >
          <div className="circle"></div>
          <h4 className="clr-green fs-700">{t("factory.ourFactory")}</h4>
        </div>
        <h2
          ref={headingRef}
          className={`fs-1000 clr-dark ${headingVisible ? "animate-in" : ""}`}
        >
          {t("factory.title")}
        </h2>
        <div
          ref={sliderRef}
          className={`factory-slider flex ${sliderVisible ? "animate-in" : ""}`}
          style={{
            backgroundImage: `linear-gradient(0deg, rgba(25, 24, 24, 0.84), rgba(25, 24, 24, 0.84)), linear-gradient(270deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 95.85%), url(${slideContent[currentSlide].img})`,
          }}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseUp}
          onTouchStart={handleMouseDown}
          onTouchMove={handleMouseMove}
          onTouchEnd={handleMouseUp}
        >
          <div className="factory-slider-content">
            <h3 className="fs-1000 clr-white">
              {slideContent[currentSlide].title}
            </h3>
            <p className="clr-white fs-500">
              {slideContent[currentSlide].description}
            </p>
          </div>

          <div className="factory-slider-images">
            {slideContent.map((slide, index) => (
              <img
                key={index}
                className={`factory-slider-img factory-slider-img-${getImagePosition(
                  index
                )}`}
                src={slide.img}
                alt={slide.title}
                draggable="false"
              />
            ))}
          </div>

          <div className="factory-slider-arrows flex">
            <img
              src="/assets/icons/arrowLeft.svg"
              alt="Arrow Left Icon"
              onClick={prevSlide}
              style={{ cursor: "pointer" }}
            />
            <img
              src="/assets/icons/arrowRight.svg"
              alt="Arrow Right Icon"
              onClick={nextSlide}
              style={{ cursor: "pointer" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Factory;
